/**
 * Configuración centralizada de la API
 * 
 * IMPORTANTE: Para cambiar entre desarrollo y producción, 
 * solo necesitas modificar la URL en API_BASE_URL
 */

// =====================================================
// CONFIGURACIÓN DE ENTORNO
// =====================================================

// URL base de la API - CAMBIAR AQUÍ para alternar entre entornos
// Desarrollo: 'http://localhost:5027/api'
// Test: 'https://cotizar.alianzatest.com/api'
// Producción: 'https://cotizar.alianzateam.com/api'
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://cotizar.alianzateam.com/api';

// URL base sin /api para endpoints que no usan el prefijo /api
export const API_HOST = API_BASE_URL.replace('/api', '');

// =====================================================
// CONFIGURACIÓN EXPORTADA
// =====================================================

const apiConfig = {
  // URL completa con /api
  baseUrl: API_BASE_URL,
  
  // URL del host sin /api
  host: API_HOST,
  
  // Timeout para peticiones (en milisegundos)
  timeout: 30000,
  
  // Endpoints específicos
  endpoints: {
    // Auth
    login: `${API_BASE_URL}/auth/login`,
    registro: `${API_BASE_URL}/auth/registro`,
    registroSimple: `${API_BASE_URL}/auth/registro-simple`,
    resetPassword: `${API_BASE_URL}/auth/reset-password`,
    
    // Azure
    azureConfig: `${API_BASE_URL}/azure/config`,
    azureCallback: `${API_BASE_URL}/azure/callback`,
    
    // Rutas
    rutasTest: `${API_BASE_URL}/rutas/test-frontend`,
    rutasTabla: `${API_BASE_URL}/rutas/tabla-real`,
    
    // Admin
    preguntas: `${API_BASE_URL}/preguntas`,
    preguntasCrear: `${API_BASE_URL}/preguntas/crear`,
    preguntasResponder: `${API_BASE_URL}/admin/preguntas/responder`,
    licitaciones: `${API_BASE_URL}/admin/licitaciones`,
    sicetacTarifas: `${API_BASE_URL}/admin/sicetac-tarifas`,
    sicetacActualizar: `${API_BASE_URL}/admin/sicetac-tarifas/actualizar`,
    
    // Huella de carbono
    huellaCarbono: `${API_BASE_URL}/huella-carbono/registro`,
    
    // Upload de archivos (públicos)
    uploadPlanDescarbonizacion: `${API_BASE_URL}/upload/plan-descarbonizacion-publico`,
    uploadBrochure: `${API_BASE_URL}/upload/brochure-publico`,
    uploadOtraCertificacion: `${API_BASE_URL}/upload/otra-certificacion-publico`,
    
    // Test
    testSimpleRegistro: `${API_BASE_URL}/test/simple-registro`,
  }
};

export default apiConfig;

